
const digest = '629ff9f48378c90d8a6898fded788f2dec1a8c248c31bea5d24ca50a09765411';
const classes = {"wrapper":"_wrapper_1oj1l_1","reverse":"_reverse_1oj1l_11","icons":"_icons_1oj1l_16","iconWithBadge":"_iconWithBadge_1oj1l_23","icon":"_icon_1oj1l_16","badge":"_badge_1oj1l_33","connector":"_connector_1oj1l_44","tooltipIcons":"_tooltipIcons_1oj1l_48","tooltipIcon":"_tooltipIcon_1oj1l_48"};
const css = `._wrapper_1oj1l_1 {
  display: flex;
  flex-direction: column;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  align-items: center;
}

._reverse_1oj1l_11 {
  flex-direction: column-reverse;
  top: auto;
}

._icons_1oj1l_16 {
  display: flex;
  flex-wrap: wrap;
  max-width: 40px;
  justify-content: space-around;
}

._iconWithBadge_1oj1l_23 {
  position: relative;
  display: inline-block;
}

._icon_1oj1l_16 {
  width: 20px;
  display: block;
}

._badge_1oj1l_33 {
  position: absolute;
  top: -2px;
  right: -2px;
  width: 6px;
  height: 6px;
  background-color: #e13830;
  border-radius: 50%;
  border: 1px solid white;
}

._connector_1oj1l_44 {
  text-align: center;
}

._tooltipIcons_1oj1l_48 {
  display: flex;
  gap: 8px;
  align-items: center;
}

._tooltipIcon_1oj1l_48 {
  width: 20px;
  height: auto;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  